import React from 'react';
    import { motion } from 'framer-motion';

    const WhyThisMatters = () => {
      const externalLink = "https://members.sellersanonymous.org/";
      
      const principles = [
        { title: 'Be buyer-centric', description: 'prioritise their interests in creating solutions, not our commission' },
        { title: 'Act with integrity', description: 'be ethical, honest, transparent, and free of bias' },
        { title: 'Seek to understand', description: 'their situation, requirements, desired outcomes, and what value means to them' },
        { title: 'Focus on their outcomes', description: 'co-create real solutions; it\'s only a solution when they say it is' },
        { title: 'Reduce their risk', description: 'acknowledge change creates risk and help them see and mitigate it' },
        { title: 'Respect their timelines', description: 'they buy when they\'re ready; our targets are not their problem' }
      ];

      return (
        <section className="py-20 bg-gradient-to-br from-slate-50 to-cyan-50">
          <div className="container">
            <div className="max-w-4xl mx-auto">
              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                whileInView={{ opacity: 1, y: 0 }} 
                viewport={{ once: true }} 
                transition={{ duration: 0.6 }} 
                className="text-center mb-12"
              >
                <h2 className="text-3xl md:text-4xl font-bold text-slate-800 mb-6">
                  Ethical. Buyer-Centric. Still Commercial.
                </h2>
                <p className="text-xl text-slate-600 leading-relaxed">
                  The principles we follow are based on{' '}
                  <a href="https://thesellercode.org/" target="_blank" rel="noopener noreferrer" className="text-cyan-600 hover:text-cyan-700 underline">
                    The Seller Code
                  </a> — a commitment to selling that is ethical, transparent, and buyer-centric.
                </p>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                whileInView={{ opacity: 1, y: 0 }} 
                viewport={{ once: true }} 
                transition={{ duration: 0.6, delay: 0.2 }} 
                className="bg-white rounded-2xl p-8 shadow-lg border border-slate-200"
              >
                <h3 className="text-xl font-semibold text-slate-800 mb-8 text-center">
                  In practice, that means we aim to:
                </h3>
                <div className="grid gap-6 md:gap-8">
                  {principles.map((principle, index) => (
                    <motion.div 
                      key={index} 
                      initial={{ opacity: 0, x: -20 }} 
                      whileInView={{ opacity: 1, x: 0 }} 
                      viewport={{ once: true }} 
                      transition={{ delay: index * 0.1 }} 
                      className="flex items-start space-x-4"
                    >
                      <div className="w-8 h-8 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                        <div className="w-3 h-3 bg-white rounded-full"></div>
                      </div>
                      <div>
                        <h4 className="font-semibold text-slate-800 mb-1">{principle.title}</h4>
                        <p className="text-slate-600">– {principle.description}</p>
                      </div>
                    </motion.div>
                  ))}
                </div>
              </motion.div>

              <motion.div 
                initial={{ opacity: 0, y: 30 }} 
                whileInView={{ opacity: 1, y: 0 }} 
                viewport={{ once: true }} 
                transition={{ duration: 0.6, delay: 0.4 }} 
                className="text-center mt-12"
              >
                <p className="text-lg text-slate-600 mb-2">
                  If you've ever felt a knot in your stomach after a deal closed, you're not alone.
                </p>
                <p className="text-lg text-slate-600 mb-8 font-medium">
                  Come talk to people who sell hard without hardening themselves.
                </p>
                <a 
                  href={externalLink}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block bg-cyan-600 hover:bg-cyan-700 text-white px-8 py-3 rounded-lg font-semibold transition-all duration-200 hover:shadow-lg hover:scale-105"
                >
                  Join a Meeting
                </a>
              </motion.div>
            </div>
          </div>
        </section>
      );
    };

    export default WhyThisMatters;